export default __webpack_public_path__ + "static/authentication-page-2fc5723b3be74bff5cea018a40c19a81.png";